import { useEffect, useState } from "preact/hooks";

/**
 * Debug readout for device checks (`&debug`): median and 5th-percentile FPS over each second, from
 * display-frame intervals. P2-AN-04's perf_sample will report the same numbers as telemetry.
 */
export function FpsOverlay() {
  const [text, setText] = useState("measuring…");
  useEffect(() => {
    let raf = 0;
    let last = performance.now();
    let windowStart = last;
    const gaps: number[] = [];
    const loop = (now: number) => {
      gaps.push(now - last);
      last = now;
      if (now - windowStart >= 1000 && gaps.length > 0) {
        const sorted = [...gaps].sort((a, b) => a - b);
        const p50 = sorted[Math.floor(sorted.length / 2)] ?? 0;
        const p95 = sorted[Math.min(sorted.length - 1, Math.floor(sorted.length * 0.95))] ?? 0;
        setText(`${Math.round(1000 / p50)} fps · p5 ${Math.round(1000 / p95)} fps`);
        gaps.length = 0;
        windowStart = now;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
    };
  }, []);
  return <p class="debug">{text}</p>;
}
